<template>
    <ul class="flash-messages" v-if="show">
        <li
            :class="message.status"
            v-for="message in messages"
            :key="message.key"
            @mouseenter="message.enter"
            @mouseleave="message.leave"
        >
            <i class="material-icons icon" v-if="message.icon">{{ message.icon }}</i>
            <span class="message">{{ message.message }}</span>
            <a href="#" @click.prevent="message.callback" v-if="message.link && message.callback" class="callback">{{
                message.link
            }}</a>
            <a href="#" @click.prevent="message.dismiss" class="material-icons close">close</a>
        </li>
    </ul>
</template>
<script>
export default {
    name: 'FlashMessages',
    computed: {
        show() {
            return this.messages.length > 0
        },
        messages() {
            return this.$store.getters.flashMessages
        },
    },
}
</script>
<style>
.flash-messages {
    position: absolute;
    bottom: 32px;
    left: calc(var(--side-rail-width) + 32px);
    z-index: var(--z-index-flash-messages);

    li {
        background-color: var(--color-flash-default-background);
        border-radius: 4px;
        color: var(--color-flash-light-text);
        padding: 16px 24px;
        margin-bottom: 16px;
        width: 374px;

        display: flex;
        flex-wrap: nowrap;
        flex-direction: row;
        align-items: center;

        .icon {
            margin-right: 8px;
            align-self: flex-start;
        }

        .message {
            font-size: 14px;
            flex: 1;
            line-height: 24px;
        }

        .callback {
            color: var(--color-active);
            line-height: 24px;
            font-size: 11px;
            text-transform: uppercase;
        }

        a {
            margin-left: 16px;
        }

        &.success {
            background-color: var(--color-flash-success-background);
            color: var(--color-flash-light-text);

            .callback {
                color: var(--color-flash-light-text);
                text-decoration: underline;
            }
        }

        &.error {
            background-color: var(--color-flash-error-background);
            color: var(--color-flash-light-text);

            .callback {
                color: var(--color-flash-light-text);
                text-decoration: underline;
            }
        }

        &.info {
            background-color: var(--color-flash-info-background);
            color: var(--color-flash-light-text);

            .callback {
                color: var(--color-flash-light-text);
                text-decoration: underline;
            }
        }

        &.warning {
            background-color: var(--color-flash-warning-background);
            color: var(--color-flash-dark-text);

            .callback {
                color: var(--color-flash-dark-text);
                text-decoration: underline;
            }
        }
    }
}
@media (max-width: 768px) {
    .flash-messages {
        position: absolute;
        width: 100%;
        margin: 0 auto;
        bottom: 0px;
        left: 0px;
        z-index: 2;
        li {
            width: 100%;
            padding: 24px 24px 120px 24px;
        }
    }
}
</style>
